// extracted by mini-css-extract-plugin
export default {"tableActions":"TableActionHandler_tableActions__NQQeb","iconDiv":"TableActionHandler_iconDiv__2PNZG"};